export default function (utente) {
  this.id = utente ? utente.id : null;
  this.createdAt = utente ? utente.createdAt : null;
  this.updatedAt = utente ? utente.updatedAt : null;
  this.username = utente ? utente.username : null;
  this.confirmed = utente ? utente.confirmed : false;
  this.role = utente ? utente.role : null;
  this.isAttivo = utente ? utente.isAttivo : false;
}
